<div class="container-fluid h-100">
  <div class="row">
    <div class="col-12">
      <span class="title">{{ content.title }}</span>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <p-divider styleClass="divider-m-5"></p-divider>
    </div>
  </div>
  <div class="container-fluid mb-3 container-content">
    <div class="row" *ngFor="let item of annoucementList">
      <div class="col-12">
        <div class="flex-container">
          <div class="flex-item bottom-dashed-shadow content-width">
            <div>
              <span class="name" title="{{ item.title }}">{{ item.title }}</span>
            </div>
            <div>
              <span class="description" title="{{ item.datatime }}">{{ item.datatime }}</span>
            </div>
            <div>
              <span class="sub-description" title="{{ item.message }}">Check
                {{ item.message }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="row pb-3">
    <div class="col-12 text-center">
      <a class="link">{{ content.footerLink }}</a>
    </div>
  </div> -->
</div>
